import { CompanyData } from './company.types';
import { getTriumphData } from './triumph';

//TODO: Update domains to expected url
export enum Domains {
    LOCALHOST = 'localhost',
    SANDBOX = 'myfactoringservice.com',
    ORYX = 'factoringbydelta.com',
    FAAS_BY_TRIUMPH = 'faasbytriumph.io',
}

const domainCompanyMap: Record<Domains, () => CompanyData> = {
    [Domains.LOCALHOST]: getTriumphData,
    [Domains.SANDBOX]: getTriumphData,
    [Domains.ORYX]: getTriumphData,
    [Domains.FAAS_BY_TRIUMPH]: getTriumphData,
};

export const getCompanyData: () => CompanyData = () => {
    const hostname = window.location.hostname;
    const companyKey = Object.keys(domainCompanyMap).find((domain) => {
        return hostname.includes(domain);
    });
    if (companyKey) {
        return domainCompanyMap[companyKey as keyof typeof domainCompanyMap]();
    } else {
        return getTriumphData();
    }
};
